import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, INACTIVE_GRAY, NIGHTINGALE_BLACK, RIOJA_RED, RIOJA_RED_FOCUSED } from '../../colors';
import { css } from 'styled-components';
import { getVariantName } from '../../helpers/variants';
const LINK_COLOR = {
  default: NIGHTINGALE_BLACK,
  secondary: INACTIVE_GRAY,
  primary: ADVENTURE_GREEN,
  alarm: RIOJA_RED,
  dark: NIGHTINGALE_BLACK
};
const LINK_HOVER_COLOR = {
  default: ADVENTURE_GREEN,
  secondary: ADVENTURE_GREEN,
  primary: ADVENTURE_GREEN_FOCUSED,
  alarm: RIOJA_RED_FOCUSED,
  dark: ADVENTURE_GREEN
};
const LINK_BORDER_BOTTOM = {
  default: `1px solid ${ADVENTURE_GREEN}`,
  secondary: 'none',
  primary: 'none',
  alarm: 'none',
  dark: 'none'
};
export const baseLinkMixin = css`
  color: ${props => LINK_COLOR[getVariantName(props)] || LINK_COLOR.default};
  border-bottom: ${props => LINK_BORDER_BOTTOM[getVariantName(props)] || LINK_BORDER_BOTTOM.default};
  &:hover,
  &:active {
    color: ${props => LINK_HOVER_COLOR[getVariantName(props)] || LINK_HOVER_COLOR.default};
  }
`;